import * as React from "react";

const NLFlag = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={25}
		height={16}
		viewBox="0 0 9 6"
		{...props}
	>
		<rect fill="#21468B" width={9} height={6} />
		<rect fill="#FFF" width={9} height={4} />
		<rect fill="#AE1C28" width={9} height={2} />
	</svg>
);

export default NLFlag;
